import { useMutation, useQueryClient } from "@tanstack/react-query";
import { authService } from "@/entities/session/api/authService";
import { removeToken, saveAuthData, saveRefreshToken, saveToken } from "@/shared/lib/token";
import { reloadAt } from "@/shared/lib/router/reload";

type SwitchTenantInput = {
    tenantId: string;
    /** Endereço a abrir já com a sessão da nova organização. */
    destination: string;
};

/** Troca os tokens pelos de outra organização da pessoa e recarrega a aplicação nela. */
export function useSwitchTenant() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({ tenantId }: SwitchTenantInput) => authService.switchTenant({ tenantId }),
        onSuccess: (session, { destination }) => {
            removeToken();
            saveToken(session.accessToken);
            if (session.refreshToken) saveRefreshToken(session.refreshToken);
            saveAuthData(session.permissions, session.roles);
            queryClient.clear();
            // Menus, contextos e caches de toda a aplicação são da organização anterior: recarregar é o reset completo.
            reloadAt(destination);
        },
    });
}
